export default "__VITE_ASSET__DAtveJi6__"